import { useState, useEffect } from 'react';

/**
 * Fetches the client record for a given clientId.
 *
 * Uses APIHelper.fetchLookUpDetails("client", clientId).
 *
 * @param {string|null} clientId
 * @param {object}      apiClasses
 * @returns {{ client: object|null, clientName: string|null, clientLoading: boolean }}
 */
export const useClient = (clientId, apiClasses) => {
    const [client, setClient] = useState(null);
    const [clientLoading, setClientLoading] = useState(false);

    useEffect(() => {
        if (!clientId || !apiClasses?.APIHelper) return;

        setClientLoading(true);
        apiClasses.APIHelper.fetchLookUpDetails('client', clientId)
            .then(({ data }) => {
                if (data?.success && data?.payload) {
                    setClient(data.payload);
                }
            })
            .catch((err) => {
                console.warn('[useClient] Failed to fetch client:', err?.message ?? err);
            })
            .finally(() => setClientLoading(false));
    }, [clientId, apiClasses?.APIHelper]);

    return { client, clientName: client?.name ?? null, clientLoading };
};
